import type { User } from './user.interface';

/**
 * Metadata de cache para datos de usuario
 * @author Omar Sánchez Martinez
 * @since 10/02/2026
 */
export interface UserCacheMetadata {
  /** Timestamp de última actualización (ms) */
  lastFetched: number;
  /** TTL en milisegundos (default: 2 horas) */
  ttl: number;
}

/**
 * Datos de usuario con metadata de cache
 */
export interface CachedUser {
  data: User;
  metadata: UserCacheMetadata;
}

/**
 * Configuración de TTL
 * 2 horas = 7200000 ms
 */
export const USER_DATA_TTL = 7200000;
